import sha1 from 'simple-sha1';
import utf16ToUTF8Array from '@stdlib/string-utf16-to-utf8-array';

export function urlToLocation(url: string) {
  const u = new URL(url, location.href);

  const searchParams = {};
  new URLSearchParams(u.search).forEach(
    (value: string, key: string) => (searchParams[key] = value),
  );

  return {
    path: u.pathname,
    query: u.search?.startsWith('?') ? u.search.substring(1) : u.search,
    queryMap: searchParams,
    hash: u.hash,
  };
}

/**
 * Sign query params with SHA1 using the same pattern as RequestInterceptor._s().
 */
export function signQueryParams(
  params: Record<string, unknown>,
  clientSecret: string,
): string {
  const sortedKeys = Object.keys(params)
    .filter((k) => k !== 'sig' && params[k] !== undefined)
    .sort();

  const queryString = sortedKeys
    .map((k) => `${k}=${params[k]}`)
    .join('&');

  const parts = [clientSecret, queryString, clientSecret];

  return sha1
    .sync(utf16ToUTF8Array(parts.join('|')) as any)
    .substring(0, 16);
}
